import {
  Button,
  ErrorDialog,
  SquareNewWindowIcon,
  Typography,
} from "@codat/orchard-ui";
import axios from "axios";
import { useGetCompany } from "hooks/query/useGetCompany";
import React from "react";
import { useParams } from "react-router-dom";

import { ConnectionErrorsTable } from "./ConnectionErrorsTable";
import styles from "./ConnectionManagement.module.scss";
import { ConnectionsTable } from "./ConnectionsTable";

export const ConnectionManagement = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const {
    data: company,
    error,
    isLoading,
    refetch,
  } = useGetCompany({ companyId });

  if (error) {
    return (
      <ErrorDialog
        statusCode={
          axios.isAxiosError(error) ? error.response?.status : undefined
        }
        message={
          axios.isAxiosError(error) ? error.response?.statusText : undefined
        }
      />
    );
  }
  return (
    <>
      <div className={styles.titleContainer}>
        <Typography as="h2" variant="heading_xl">
          Manage connections
        </Typography>
        <Button
          color="interface"
          variant="secondary"
          target="_blank"
          data-testid="documentation-button"
          aria-label="Documentation"
          href="https://docs.codat.io/core-concepts/connections"
          className={styles.documentationButton}
        >
          <span
            style={{
              marginRight: "0.5rem",
            }}
          >
            Learn about connections
          </span>
          <SquareNewWindowIcon />
        </Button>
      </div>
      <div className={styles.pageContainer}>
        <div>
          <Typography as="h3" variant="heading_md">
            Connections
          </Typography>
          <ConnectionsTable
            companyName={company?.name ?? ""}
            isSkeleton={isLoading}
            onRefetchConnections={refetch}
            dataConnections={company?.dataConnections ?? []}
          />
        </div>
        <div>
          <Typography as="h3" variant="heading_md" id="connection-errors">
            Connection errors
          </Typography>
          <ConnectionErrorsTable
            isSkeleton={isLoading}
            dataConnections={company?.dataConnections ?? []}
          />
        </div>
      </div>
    </>
  );
};
